<template>
    <v-container class="inner-main pt-2 mb-10">
        <v-row class="mx-0">
            <h2>{{ $t('global.menu.backoffice.admin') }}</h2>
        </v-row>
        <v-form ref="form" lazy-validation>
            <!-- <v-snackbar v-model="snackbar" location="top" close-delay="1500" content-class="pa-0">
                <template v-slot:default>
                    <v-alert
                        text="Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi, ratione debitis quis est labore voluptatibus! Eaque cupiditate minima, at placeat totam, magni doloremque veniam neque porro libero rerum unde voluptatem!"
                        title="Alert title" type="success"></v-alert>
                </template>
</v-snackbar> -->
            <v-row class="mb-3">
                <v-col cols="12" md="6">
                    <v-col class="align-items-center pb-0">
                        <v-label class="mr-4">{{
                            $t('global.form.username') }}</v-label>
                        <v-text-field variant="outlined" v-model="editAdmin.username" density="compact"
                            :hide-details="true" :rules="usernameRules">
                        </v-text-field>
                    </v-col>
                    <v-col class="align-items-center pb-0">
                        <v-label class="mr-4">{{ $t('global.form.email') }}</v-label>
                        <v-text-field variant="outlined" v-model="editAdmin.email" density="compact"
                            :hide-details="true" :rules="emailRules">
                        </v-text-field>
                    </v-col>
                </v-col>
                <v-col cols="12" md="6">
                    <v-col class="align-items-center pb-0">
                        <v-label class="mr-4">{{ $t('global.form.password') }}</v-label>
                        <v-text-field variant="outlined" v-model="editAdmin.password" density="compact"
                            :hide-details="true" :rules="passwordRules">
                        </v-text-field>
                    </v-col>
                    <v-col class="align-items-center pb-0">
                        <v-label class="mr-4">{{ $t('global.form.city') }}</v-label>
                        <v-autocomplete variant="outlined" v-model="editAdmin.city" density="compact"
                            :hide-details="true">
                        </v-autocomplete>
                    </v-col>
                </v-col>
                <v-col cols="12" class="justify-end d-flex">
                    <v-btn class="px-3 py-1 text-right" variant="flat" rounded="xl" size="large" color="primary"
                        @click="save">
                        {{ $t('entity.action.save') }} </v-btn>
                </v-col>
            </v-row>
        </v-form>
        <v-row>
            <v-col cols="12">
                <v-table density="compact">
                    <thead>
                        <tr>
                            <th class="text-left">
                                {{ $t('global.form.city') }}
                            </th>
                            <th class="text-left">
                                {{ $t('global.form.name') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in admins" :key="item.name">
                            <td>{{ item.city }}</td>
                            <td>{{ item.username }}</td>
                        </tr>
                    </tbody>
                </v-table>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import { ref, inject, getCurrentInstance, nextTick, useTemplateRef, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

export default {
    components: {

    },
    setup() {

        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const selectedLanguage = localStorage.getItem('selectedLanguage');
        const { t, locale } = useI18n();
        const editAdmin = ref({ username: '', email: '', password: '', city: '' });
        const form = useTemplateRef('form');
        const valid = ref(false);
        const snackbar = ref(false)
        const show1 = ref(false);


        const usernameRules = [
            v => !!v || 'Username is required',
            v => (v && v.length >= 3) || 'Username must be at least 3 characters',
        ];

        const emailRules = [
            v => !!v || 'Email is required',
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ];

        const passwordRules = [
            v => !!v || 'Password is required',
            v => (v && v.length >= 7) || 'Password must be at least 7 characters',
        ]

        const cityRules = [

        ]

        const validate = async () => {
            const { valid, errors } = await form.value.validate()
            if (!valid) {
                let errorMessages = [];
                Object.values(errors).forEach(fieldErrors => {
                    if (fieldErrors.errorMessages.length) {
                        errorMessages.push(...fieldErrors.errorMessages);
                    }
                });
                errorMessages.forEach(msg => {
                    if (msg.length) {
                        proxy.$toast.error(msg, { theme: "colored" });
                    }
                })
                // Show errors in toast
                // proxy.$toast.error("HEY I GUESS", { theme: "colored" })
                return false;
            }
            return true;
        }


        const save = async () => {
            if (validate()) return;
            console.log('save');
        }

        return {
            selectedLanguage,
            editAdmin,
            save,
            usernameRules,
            emailRules,
            // valid,
            snackbar,
            passwordRules,
            show1
        };
    },

    watch: {

    },

    data: () => ({
        admins: []
    }),

    computed: {
    },

    mounted() {
        this.fetchAdmins();
    },

    methods: {
        // notify(){
        //     this.$toast('HEY');
        // },
        fetchAdmins() {
            const hardToken = localStorage.getItem("hardToken");
            const username = localStorage.getItem("username");
            this.$axios.get("/backoffice/admins", {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-USER': username
                },
            })
                .then(this.adminsFetched)
                .catch(error => {
                    console.error("Error fetching user data:", error);
                    // You can handle specific error codes here, for example, a 401 Unauthorized
                    if (error.response && error.response.status === 401 || error.response.status === 403) {
                        // Handle token expiration or unauthorized error
                        console.log("Session expired or unauthorized. Please log in again.");
                        // Optionally log the user out or redirect to login page
                    }
                });
        },
        adminsFetched(response) {
            this.admins = response.data.data;
        }
    },
}
</script>

<style scoped>
.inner-main {
    margin-left: auto;
    margin-right: auto;
    max-width: 1170px;
    margin-top: 40px;
}
</style>

<style>
.v-snackbar__content:has(.v-alert) {
    padding: 0px !important;
}
</style>

<style></style>